var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTarefas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.204,
    height: 17.281,
    viewBox: "0 0 30.204 17.281",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(-5.998 -9.85)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_154",
    "data-name": "Ret\\xE2ngulo 154",
    width: 2.152,
    height: 14.431,
    rx: 0.641,
    transform: "translate(16.754 11.661)",
    fill: "#f6a635"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_155",
    "data-name": "Ret\\xE2ngulo 155",
    width: 10.704,
    height: 14.162,
    rx: 0.429,
    transform: "translate(18.635 11.795)",
    fill: "#fbd73b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_76",
    "data-name": "Caminho 76",
    d: "M23.7,25.7H14.322a1.083,1.083,0,0,1-.981-1.16v-12.6a1.083,1.083,0,0,1,.981-1.16H23.7a1.083,1.083,0,0,1,.981,1.16v12.6A1.083,1.083,0,0,1,23.7,25.7ZM14.322,11.541a.376.376,0,0,0-.341.4v12.6a.376.376,0,0,0,.341.4H23.7a.376.376,0,0,0,.341-.4v-12.6a.376.376,0,0,0-.341-.4Z",
    transform: "translate(4.975 0.633)",
    fill: "#f6a635"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_156",
    "data-name": "Ret\\xE2ngulo 156",
    width: 10.167,
    height: 13.277,
    rx: 0.404,
    transform: "translate(18.367 12.175)",
    fill: "#fffae8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_77",
    "data-name": "Caminho 77",
    d: "M23.544,11.973v11.8a.688.688,0,0,1-.624.739H13.993a.688.688,0,0,1-.624-.739V23.65H21.3a.688.688,0,0,0,.624-.739V11.235h1a.688.688,0,0,1,.624.739Z",
    transform: "translate(4.994 0.938)",
    fill: "#efe8d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_78",
    "data-name": "Caminho 78",
    d: "M20.943,13.85h-6.56a.292.292,0,0,1,0-.575h6.56a.292.292,0,0,1,0,.575Z",
    transform: "translate(5.519 2.321)",
    fill: "#efe8d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_79",
    "data-name": "Caminho 79",
    d: "M18.735,12.7H15.58a.292.292,0,0,1,0-.575h3.156a.292.292,0,0,1,0,.575Z",
    transform: "translate(6.329 1.538)",
    fill: "#efe8d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_80",
    "data-name": "Caminho 80",
    d: "M20.943,16.305h-6.56a.292.292,0,0,1,0-.575h6.56a.292.292,0,0,1,0,.575Z",
    transform: "translate(5.519 3.985)",
    fill: "#efe8d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81",
    "data-name": "Caminho 81",
    d: "M20.943,18.761h-6.56a.292.292,0,0,1,0-.575h6.56a.292.292,0,0,1,0,.575Z",
    transform: "translate(5.519 5.649)",
    fill: "#efe8d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_157",
    "data-name": "Ret\\xE2ngulo 157",
    width: 10.704,
    height: 14.162,
    rx: 0.429,
    transform: "translate(17.024 25.957) rotate(180)",
    fill: "#fbd73b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_82",
    "data-name": "Caminho 82",
    d: "M16.363,25.7H6.982A1.083,1.083,0,0,1,6,24.542v-12.6a1.083,1.083,0,0,1,.981-1.16h9.381a1.083,1.083,0,0,1,.981,1.16v12.6A1.083,1.083,0,0,1,16.363,25.7ZM6.982,11.541a.376.376,0,0,0-.341.4v12.6a.376.376,0,0,0,.341.4h9.381a.376.376,0,0,0,.341-.4v-12.6a.376.376,0,0,0-.341-.4Z",
    transform: "translate(0 0.633)",
    fill: "#f6a635"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_158",
    "data-name": "Ret\\xE2ngulo 158",
    width: 10.268,
    height: 13.277,
    rx: 0.406,
    transform: "translate(17.394 25.452) rotate(180)",
    fill: "#fffae8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_83",
    "data-name": "Caminho 83",
    d: "M16.822,11.973v11.8a.688.688,0,0,1-.624.739H7.271a.688.688,0,0,1-.624-.739V23.65h7.93a.688.688,0,0,0,.624-.739V11.235h1a.688.688,0,0,1,.624.739Z",
    transform: "translate(0.439 0.938)",
    fill: "#efe8d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_84",
    "data-name": "Caminho 84",
    d: "M8,13.85h6.56a.292.292,0,0,0,0-.575H8a.292.292,0,0,0,0,.575Z",
    transform: "translate(1.195 2.321)",
    fill: "#efe8d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85",
    "data-name": "Caminho 85",
    d: "M8.836,12.7h3.156a.292.292,0,0,0,0-.575H8.836a.292.292,0,0,0,0,.575Z",
    transform: "translate(1.759 1.538)",
    fill: "#efe8d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_86",
    "data-name": "Caminho 86",
    d: "M8,16.305h6.56a.292.292,0,0,0,0-.575H8a.292.292,0,0,0,0,.575Z",
    transform: "translate(1.195 3.985)",
    fill: "#efe8d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_87",
    "data-name": "Caminho 87",
    d: "M8,18.761h6.56a.292.292,0,0,0,0-.575H8a.292.292,0,0,0,0,.575Z",
    transform: "translate(1.195 5.649)",
    fill: "#efe8d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_88",
    "data-name": "Caminho 88",
    d: "M29.21,23.605,24.3,18.942a5.941,5.941,0,0,0,.882-3.088,6.058,6.058,0,1,0-2.454,4.816L27.6,25.3a1.168,1.168,0,1,0,1.608-1.693ZM14.342,15.854a4.836,4.836,0,1,1,4.836,4.836,4.836,4.836,0,0,1-4.836-4.836Z",
    transform: "translate(4.864)",
    fill: "#5d88ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_89",
    "data-name": "Caminho 89",
    d: "M26.61,22.436a.755.755,0,0,1-.2.175,1.818,1.818,0,0,1-2.4-.022l-4.228-3.724a.95.95,0,0,1-.274-1.008,1.1,1.1,0,0,1,.186-.329l1.194-1.336a.94.94,0,0,1,1.336-.088l4.217,3.724a1.842,1.842,0,0,1,.164,2.607Z",
    transform: "translate(9.128 4.078)",
    fill: "#082233"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_90",
    "data-name": "Caminho 90",
    d: "M26.413,22.337a1.818,1.818,0,0,1-2.4-.022l-4.228-3.724a.95.95,0,0,1-.274-1.008l.876-.986a.941.941,0,0,1,1.336-.088l4.217,3.724A1.816,1.816,0,0,1,26.413,22.337Z",
    transform: "translate(9.128 4.353)",
    fill: "#153649"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTarefas);
export default __webpack_public_path__ + "static/media/tarefas.634fea185fda2a264b274f70f01c32f7.svg";
export { ForwardRef as ReactComponent };